import React, {useEffect, useState} from "react";

import {useDispatch, useSelector} from "react-redux";
import {makeStyles} from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(theme => ({
    dashboardSection: {
        // padding: "5px"
    },
}));


const EstadoOS = ({
                     ordemServico
                          }) => {
    const classes = useStyles();

    const [show, setShow] = useState(false);
    const st = useSelector(state => state);
    console.log("REDUX STATE", st)
    const etapas = useSelector(state => state.stations.etapas);
    const periodMin = useSelector(state => state.filter.periodMin);
    const periodMax = useSelector(state => state.filter.periodMax);

    const dispatch = useDispatch();


    return (
        <React.Fragment>
            <Grid>
                <Paper>
                    <Typography>{ordemServico.ordemServicoId}</Typography>
                </Paper>
            </Grid>
        </React.Fragment>
    )

}

export default EstadoOS;
